import { render } from "./ClienteDetail.vue?vue&type=template&id=dd1c1044&scoped=true"
import script from "./ClienteDetail.vue?vue&type=script&lang=js"
export * from "./ClienteDetail.vue?vue&type=script&lang=js"

import "./ClienteDetail.vue?vue&type=style&index=0&id=dd1c1044&scoped=true&lang=css"

import exportComponent from "/var/www/app_server_flask/temp/temp_app_ingegno_gm-system_1764364635178909029/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd1c1044"]])

export default __exports__